import { FunctionComponent } from 'react';
import AppBar from '@mui/material/AppBar';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import { Account } from './Account/Account';
import { AppNavigation } from './AppNavigation/AppNavigation';
import { AppTitle } from './AppTitle/AppTitle';
import { IAppHeaderProps } from './AppHeader.interface';

const HeaderStack = styled(Stack)({
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  width: '100%',
});

export const AppHeader: FunctionComponent<IAppHeaderProps> = (props) => {
  const {
    title,
    logo,
    navigation,
    slots,
    slotProps,
  } = props;

  const ToolbarActionsSlot = slots?.toolbarActions;
  const ToolbarAccountSlot = slots?.toolbarAccount ?? Account;

  return (
    <AppBar color={'inherit'} position={'absolute'} sx={{ displayPrint: 'none' }}>
      <Toolbar sx={{ backgroundColor: 'inherit', mx: { xs: -0.75, sm: -1.5 } }}>
        <HeaderStack direction={'row'}>
          <Stack direction={'row'}>
            <AppTitle title={title} logo={logo} />
            <AppNavigation navigation={navigation} />
          </Stack>
          <Stack
            direction={'row'}
            sx={{
              alignItems: 'center',
              gap: 4,
              marginLeft: 'auto',
            }}>
            {slots?.toolbarActions && <ToolbarActionsSlot {...slotProps?.toolbarActions} />}
            <ToolbarAccountSlot {...slotProps?.toolbarAccount} />
          </Stack>
        </HeaderStack>
      </Toolbar>
    </AppBar>
  );
};
